// This set of utils is for use with ref objects
export const handleScrollInto = (ref: React.RefObject<HTMLDivElement>) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (ref as any).current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
};
